import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { CommentElement_element$data } from "../../__generated__/CommentElement_element.graphql";
import { CommentElement_screener$data } from "../../__generated__/CommentElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: CommentElement_element$data;
  screener: CommentElement_screener$data;
} & CommonElementProps;
const CommentElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(CommentElement, {
  element: graphql`
    fragment CommentElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment CommentElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
